import { useEffect, useState } from 'react';
import { getPendingBalance } from '../services';
import { IPendingBalanceItem, HookState, SeverityLevel } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function usePendingBalance(options?: {
	sellerId?: number;
	team?: string;
	severity?: SeverityLevel;
	enabled?: boolean;
}): HookState<IPendingBalanceItem[]> {
	const [state, setState] = useState<HookState<IPendingBalanceItem[]>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const sellerId = options?.sellerId;
	const team = options?.team;
	const severity = options?.severity;
	const enabled = options?.enabled ?? true;

	useEffect(() => {
		if (!enabled) return;

		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getPendingBalance({ sellerId, team, severity })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [sellerId, team, severity, enabled]);

	return state;
}
